<!--- ViewPort -->
<div>
  <app-header [isAuth]="true"></app-header>
  <router-outlet #outlet="outlet"></router-outlet>
  <app-footer></app-footer>
</div>